import {JSONModel, jsonProperty} from "../json.model";

export class SmartsheetTokenModel extends JSONModel {
  @jsonProperty("string") access_token: string;
  @jsonProperty("string") token_type: string;
  @jsonProperty("string") refresh_token: string;
  @jsonProperty("number") expires_in: number;
  @jsonProperty("number") expire_ts: number;
}
